import { Link, useNavigate } from "react-router-dom";
import { useStore } from "./StoreLayout";
import { money, fileUrl } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { ShoppingCart, Minus, Plus, Trash2, Package } from "lucide-react";

export default function Cart() {
  const { slug, cart, updateQty, cartCount, isCustomer, store } = useStore();
  const navigate = useNavigate();
  const subtotal = cart.reduce((s, i) => s + i.price * i.quantity, 0);

  const goCheckout = () => {
    if (!isCustomer) { navigate(`/store/${slug}/login?redirect=checkout`); return; }
    navigate(`/store/${slug}/checkout`);
  };

  if (cartCount === 0) return (
    <div className="max-w-2xl mx-auto px-6 py-20 text-center">
      <ShoppingCart className="h-12 w-12 mx-auto text-muted-foreground/40 mb-4" />
      <h1 className="text-2xl font-bold">Your cart is empty</h1>
      <Link to={`/store/${slug}`}><Button className="mt-6 rounded-full" data-testid="cart-browse-btn">Browse products</Button></Link>
    </div>
  );

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8">
      <h1 className="text-2xl sm:text-3xl font-bold tracking-tight mb-6">Your cart</h1>
      <div className="space-y-3">
        {cart.map((i) => (
          <Card key={i.product_id} className="p-4 rounded-xl border-border flex items-center gap-4" data-testid={`cart-item-${i.product_id}`}>
            <div className="h-16 w-16 rounded-lg bg-secondary overflow-hidden shrink-0 flex items-center justify-center">
              {i.image ? <img src={fileUrl(i.image)} alt="" className="w-full h-full object-cover" /> : <Package className="h-6 w-6 text-muted-foreground/40" />}
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-medium truncate">{i.name}</p>
              <p className="text-sm text-muted-foreground">{money(i.price)}</p>
            </div>
            <div className="flex items-center border border-border rounded-lg">
              <button onClick={() => updateQty(i.product_id, i.quantity - 1)} className="p-2 hover:bg-secondary" data-testid={`cart-minus-${i.product_id}`}><Minus className="h-3.5 w-3.5" /></button>
              <span className="w-8 text-center text-sm font-medium">{i.quantity}</span>
              <button onClick={() => updateQty(i.product_id, i.quantity + 1)} className="p-2 hover:bg-secondary" data-testid={`cart-plus-${i.product_id}`}><Plus className="h-3.5 w-3.5" /></button>
            </div>
            <span className="font-semibold w-20 text-right hidden sm:block">{money(i.price * i.quantity)}</span>
            <button onClick={() => updateQty(i.product_id, 0)} className="text-muted-foreground hover:text-destructive p-1" data-testid={`cart-remove-${i.product_id}`}><Trash2 className="h-4 w-4" /></button>
          </Card>
        ))}
      </div>
      <Card className="mt-6 p-5 rounded-xl border-border">
        <div className="flex items-center justify-between text-lg font-bold mb-4">
          <span>Subtotal</span><span data-testid="cart-subtotal">{money(subtotal)}</span>
        </div>
        <Button onClick={goCheckout} className="w-full h-12 rounded-full" data-testid="checkout-btn">
          {isCustomer ? "Proceed to checkout" : "Sign in to checkout"}
        </Button>
      </Card>
    </div>
  );
}
